import { jsx } from 'react/jsx-runtime';
import { DotsLoader } from '../loader/dots-loader.js';

const getLoaderSize = (size) => {
  switch (size) {
    case "small":
      return 14;
    case "large":
    default:
      return 16;
  }
};
const LoadingSpinner = ({ size }) => jsx(DotsLoader, { size: getLoaderSize(size) });

export { LoadingSpinner };
